import axios from "axios";
import { authHeaderJson } from "../auth-header.service";



const getAllBusinessUnits = () => {
    return axios.get(`/api/businessUnit`, { headers: authHeaderJson() } )
};
const getBusinessUnits = () => {
    return axios.get(`/api/businessUnit/list`, { headers: authHeaderJson() } )
};

const getBusinessUnitsFiltred = () => {
    return axios.get(`/api/businessUnit/client/list`, { headers: authHeaderJson() } )
};

const getBusinessUnitById = (businessUnitId) => {
        return axios.get(`/api/businessUnit/${businessUnitId}`, { headers: authHeaderJson() } );
};

const addBusinessUnit = (businessUnit) => {
    return axios.post(`/api/businessUnit/add/`, businessUnit, { headers: authHeaderJson() } );
}
const addBusinessUnitList = (businessUnits) => {
    return axios.post(`/api/businessUnit/add/list`, businessUnits, { headers: authHeaderJson() } );
}
const saveBusinessUnitById = (businessUnitId, objBusinessUnit) => {
    return axios.put(`/api/businessUnit/update/${businessUnitId}`, objBusinessUnit, { headers: authHeaderJson() });
};
const deleteBusinessUnit = (businessUnitId) => {
    return axios.delete(`/api/businessUnit/delete/${businessUnitId}`, { headers: authHeaderJson() });
}

export {
    getAllBusinessUnits,
    getBusinessUnits,
    getBusinessUnitsFiltred,
    getBusinessUnitById,
    addBusinessUnit,
    addBusinessUnitList,
    saveBusinessUnitById,
    deleteBusinessUnit
}